<template>
        <a-modal :title="ModalTitle" v-model="visible" :confirmLoading="confirmLoading"
            cancelText="取消" centered okText="分配" width="400px"
            @ok="handleOk" @cancel="handleCancel">
            <a-form layout="vertical">
                <a-form-item  label="分配方式">
                    <a-radio-group v-model='assign_type'>
                        <a-radio value="sort_assign">顺序平均</a-radio>
                        <a-radio value="rand_assign">随机平均</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item  label="请选择校区">
                    <a-select :not-found-content="fetching ? undefined : null" style="width: 100%" v-model='studio_id' @change="handleChange" @search='handleSearch' showSearch placeholder="请选择校区" :filterOption="filterStudio">
                        <template slot="notFoundContent">
                            <div style="height:50px">
                                <vue-element-loading :active="fetching" color="#00cca2" spinner="spinner"/>
                            </div>
                        </template>
                        <a-select-option v-for="(d, index) of studios" :key="index" :value="d['studio_id']">{{ d['filter_name'] }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="负责人">
                    <a-select mode="multiple" :not-found-content="fetchingS ? undefined : null" v-model="course_consultant_id" showSearch :filterOption="filterOption" style="width: 100%" :placeholder="studio_id?'请选择':'请先选择校区'">
                        <template slot="notFoundContent">
                            <div style="height:50px">
                                <vue-element-loading :active="fetchingS" color="#00cca2" spinner="spinner"/>
                            </div>
                        </template>
                        <a-select-option v-for="(d, index) of consultants" :key="index" :value="d['course_consultant_id']">
                            <div>
                                <LImg style="width:24px;height:24px;border-radius:50%;margin-right:8px" :src="d['employee_avatar']"/>
                                <span>{{ d['filter_name'] }}</span>
                            </div>
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>
</template>

<script>
    export default {
        name:'transfer',
        inject: ['parent'],
        props:['item','search','isAll'],
        data() {
            return {
                visible:false,
                fetching:false,
                fetchingS:false,
                ModalTitle: '批量分配',
                confirmLoading:false,
                studios:[],
                consultants:[],
                studio_id:undefined,
                course_consultant_id:[],
                assign_type:'sort_assign'
            }
        },
        created () {
            this.visible = true
            this.getStudio()
        },
        beforeDestroy () {
            this.visible = false
        },
        methods: {
            filterStudio(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].children[1].children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            async getConsultant(id) {
                this.fetchingS = true
                let res = await this.$store.dispatch('searchConsultantAction', {params:{studio_id:id}})
                this.consultants = res.data
                this.fetchingS = false
            },
            async getStudio(val) {
                this.fetching = true
                let res = await this.$store.dispatch('searchAllStudioAction', {params:val})
                this.studios = res.data
                this.fetching = false
            },
            async handleOk() {
                if(!this.studio_id){
                    this.$message.warning('请选择校区!')
                    return false
                }
                if(this.course_consultant_id.length == 0){
                    this.$message.warning('请选择负责人!')
                    return false
                }

                this.confirmLoading=true
                let obj = {
                    employee_id:this.course_consultant_id,
                    studio_id:this.studio_id,
                    user_id:this.item,
                    assign_type:this.assign_type
                }
                await this.$store.dispatch('poolTransferAction', {data:obj})
                .then(res=>{
                    this.$message.success('操作成功!')
                    this.visible = false
                    this.parent.hideTransfer(1)
                })
                .catch(err=>{
                    this.$message.error('操作失败!')
                    this.parent.hideTransfer(1)
                })
            },
            handleCancel(){
                this.parent.hideTransfer(0)
            },
            handleSearch(e){
                let obj = {q:e}
                this.getStudio(obj)
            },
            handleChange(val){
                this.getConsultant(val)
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>